import { validateEmail } from "~/utils/validation";

const missingSubjectMessage = "Please select a subject for your message.";
const missingMessage = "Please enter a message.";

function validateNonAuth(values) {
  let errors = {};
  if (!values.email_address || !validateEmail(values.email_address)) {
    errors.email_address = "Please enter a valid email address.";
  }
  if (!values.name) {
    errors.name = "Please enter your full name.";
  }
  if (!values.recaptchaValue) {
    errors.recaptchaValue = "Please enter the captcha.";
  }
  if (!values.subject) {
    errors.subject = missingSubjectMessage;
  }
  if (!values.message) {
    errors.message = missingMessage;
  }
  return errors;
}

// Errors for Chimney logged in users
function validateAuth(values) {
  let errors = {};
  if (!values.subject) {
    errors.subject = missingSubjectMessage;
  }
  if (!values.message) {
    errors.message = missingMessage;
  }
  return errors;
}

export { validateNonAuth, validateAuth };
